module.exports = __webpack_public_path__ + "img/menu_lainnya.5c57f42f.svg";